module.exports = __webpack_public_path__ + "img/sphone_feature_variety.682c0128.png";